module.exports = __webpack_public_path__ + "8faa2031e9d6d525cda6a1a965795337.woff";